import type { Hotspot } from '@types';
import { $editingHotspotApi } from '@stores/editingHotspotStores';
import { $sceneMapApi } from '@stores/dataStores';
import { $loadedId } from '@stores/loadedStore';
import { MainPlayer } from '@stores/krpPlayerStores';

const onHotspotMoveEnd = ({ id }: { id: string }) => {
  const player = MainPlayer.get();
  const loadedId = $loadedId.getState();
  if (!player || !loadedId) return;
  const spot = player.getHotspotById(id);
  if (!spot) return;
  const targetId = spot.getExtendData('polygonId')
    ? spot.getExtendData('polygonId')
    : id;
  $sceneMapApi.updateScene({
    id: loadedId,
    updater: (draft) => {
      if (!draft.hotspot) draft.hotspot = [] as Hotspot[];
      const item = draft.hotspot.find((x) => x.id === targetId);
      if (!item) return;
      item.icon.ath = spot.ath;
      item.icon.atv = spot.atv;
    },
  });
  $editingHotspotApi.update((draft) => {
    if (draft.id !== targetId) return;
    draft.icon.ath = spot.ath;
    draft.icon.atv = spot.atv;
  });
};

export default onHotspotMoveEnd;
